import React, { useEffect, useState } from "react";

import { useLiquity } from "../../../Hooks/LiquityContext";
import { useTransactionFunction } from "../../../Components/Transaction";
import { capitalizeFirstLetter } from "../../../Utils/string";
import { Decimal, LiquityStoreState } from "@yeti/lib-base";
import { useLiquitySelector } from "@yeti/lib-react";
import { formatWithDecimals } from "../../../Utils/number";

import CoinAmount from "../../../Components/CoinAmount";
import {
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  ModalCloseButton,
} from "@chakra-ui/modal";
import {
  Flex,
  Text,
  Button,
  Spacer,
  HStack,
  useDisclosure,
} from "@chakra-ui/react";
import { tokenDataMappingT } from "../../../TokenData";
import ProgressBar from "../../../Components/ProgressBar";

export type ConfirmVaultModalProps = {
  isOpen: boolean;
  onClose: () => void;
  mode: "deposit" | "withdraw";
  token: string;
  amount: string;
  total: number;
  userBalance: Decimal;
  userDeposit: Decimal;
};

const selector = ({ receiptPerUnderlyingRatios }: LiquityStoreState) => ({
  receiptPerUnderlyingRatios,
});

const ConfirmVaultModal: React.FC<ConfirmVaultModalProps> = ({
  isOpen,
  onClose,
  token,
  mode,
  amount,
  total,
  userBalance,
  userDeposit,
}) => {
  const { receiptPerUnderlyingRatios } = useLiquitySelector(selector);
  const {
    isOpen: isTxModalOpen,
    onOpen: onTxModalOpen,
    onClose: onTxModalClosed,
  } = useDisclosure();

  const { liquity, account } = useLiquity();

  let newAmount;

  const getFormattedValue = (value: string): number => {
    if (/^[0-9.]*$/.test(value)) {
      return +value;
    }
    return 0;
  };

  const tokenInfo = tokenDataMappingT[token];

  console.log("amount", amount);

  const formatedAmount = getFormattedValue(amount);
  if (
    mode === "deposit" &&
    formatedAmount ===
      formatWithDecimals(userBalance, tokenInfo.underlyingDecimals)
  ) {
    newAmount = userBalance;
  } else {
    if (
      formatedAmount ===
      formatWithDecimals(userDeposit, tokenInfo.underlyingDecimals)
    ) {
      newAmount = userDeposit;
    } else {
      newAmount = Decimal.fromWithPrecision(
        formatedAmount,
        tokenInfo.underlyingDecimals
      );
    }
  }

  console.log("newAmount", newAmount);

  const transactionId = token + "vault" + mode;
  const [sendTransaction] = useTransactionFunction(
    transactionId,
    mode === "deposit"
      ? liquity.send.vaultDeposit.bind(
          liquity.send,
          tokenInfo.address,
          newAmount
        )
      : liquity.send.vaultWithdraw.bind(
          liquity.send,
          tokenInfo.address,
          newAmount.mul(receiptPerUnderlyingRatios[tokenInfo.address])
        )
  );

  const onDeposit = () => {
    sendTransaction();

    onClose();
    onTxModalOpen();
  };

  const [approveTransaction] = useTransactionFunction(
    "approve",
    liquity.send.approveToken.bind(
      liquity.send,
      tokenInfo.name === "GLP"
        ? "0x0b82a1aD2138E9f62454ac41b702B64e0b73d57b"
        : tokenInfo.underlying,
      tokenInfo.address,
      Decimal.from("10000000000000000000")
    )
  );

  const onApprove = () => {
    approveTransaction();
  };

  // useEffect(() => {
  //   console.log("amountttt", amount)
  //   newAmount = amount
  // }, [amount]);

  const action = capitalizeFirstLetter(mode);
  const [step, setStep] = useState<0 | 1 | 2>(mode === "deposit" ? 0 : 2);

  const checkAllowance = async (
    token: string,
    spender: string,
    amount: Decimal
  ): Promise<boolean> => {
    const result = await liquity.getAllowanceOf(
      account,
      token,
      spender,
      amount
    );

    return result;
  };

  useEffect(() => {
    // let tot:Decimal = Decimal.ZERO
    // if (!(getFormattedValue(amount) == 0)) {
    //   tot = Decimal.from(amount)
    // }
    const open = isOpen;
    let interval: any = undefined;
    if (open) {
      interval = setInterval(async () => {
        const allowance = await checkAllowance(
          tokenInfo.name === "GLP"
            ? "0x0b82a1aD2138E9f62454ac41b702B64e0b73d57b"
            : tokenInfo.underlying,
          tokenDataMappingT[token].address,
          Decimal.from(getFormattedValue(amount))
        );
        console.log("allowance", allowance);
        if (allowance) {
          setStep(2);
        } else {
          setStep(1);
        }
      }, 1500);
    }

    return () => clearInterval(interval);
  }, [amount, isOpen]);
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="sm">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader textAlign="center" pb={1}>
          Confirm {action}
          <ModalCloseButton />
        </ModalHeader>

        <ModalBody>
          <Flex>
            <Text fontSize="md">Amount to {action}</Text>
            <Spacer />
            <CoinAmount
              amount={formatedAmount}
              token={token}
              fontWeight="bold"
              color="white"
              fontSize="md"
            />
          </Flex>
          <Flex mt={3}>
            <Text color="brand.200">New Total Deposit</Text>
            <Spacer />
            <CoinAmount
              color="white"
              amount={total}
              token={token}
              fontWeight="bold"
            />
          </Flex>
        </ModalBody>

        <ModalFooter flexDirection="column">
          <HStack spacing={6}>
            {mode === "deposit" && (
              <Button
                disabled={step === 2}
                variant={step !== 1 ? "quaternary" : "newPrimary"}
                onClick={onApprove}
              >
                Approve
              </Button>
            )}

            <Button
              variant={step !== 2 ? "quaternary" : "newPrimary"}
              onClick={onDeposit}
            >
              {action}
            </Button>
          </HStack>
          <ProgressBar step={step === 2 ? 1 : 0} w="30%" mt={2} />
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ConfirmVaultModal;
